/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_SuccessInputs */

const fr_vehicle_action_edit_success = /** @type {(inputs: Vehicle_Action_Edit_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations du véhicule enregistrées !`)
};

const en_vehicle_action_edit_success = /** @type {(inputs: Vehicle_Action_Edit_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle information saved!`)
};

/**
* | output |
* | --- |
* | "Vehicle information saved!" |
*
* @param {Vehicle_Action_Edit_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_success = /** @type {((inputs?: Vehicle_Action_Edit_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_success(inputs)
	return en_vehicle_action_edit_success(inputs)
});